<div class="m-4">
  <div class="pitchin-icon pitchin-icon-close" (click)="close()"></div>
  <div class="row pb-4">
    <div class="col-12 d-flex align-items-center">
      <div class="mr-2">
        <div
          class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-[#F5F5F5] tw-p-3"
        >
          <mat-icon svgIcon="icon-debit" class="debit-icon tw-text-[#323232]"></mat-icon>
        </div>
      </div>
      <div class="font-weight-extrabold text-black withdraw-title">
        {{ 'mysec.Withdraw' | translate }}
      </div>
    </div>
  </div>
  <form (ngSubmit)="submit()" [formGroup]="form" [class.show-form-error]="showFormError">
    <div class="row pb-3">
      <div class="col-12 input-panel">
        <div class="input-label font-size-smaller">{{ 'mysec.amount' | translate }}</div>
        <div class="d-flex">
          <div class="position-relative currency-panel w-100 mr-2">
            <div class="currency text-primary">RM</div>
            <input
              type="text"
              class="form-control"
              placeholder="0.00"
              formControlName="amount"
              digitOnly
              decimal="true"
              [pattern]="DoubleDecimalPattern"
            />
          </div>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="isBelowMinimum"
            [class.tw-opacity-40]="isBelowMinimum"
            (click)="setMax()"
          >
            {{ 'mysec.max' | translate }}
          </button>
        </div>
        @if (
          showFormError && form.controls.amount.errors && form.controls.amount.hasError('pattern')
        ) {
          <div class="text-danger tw-mb-2 tw-text-xs tw-font-semibold">
            {{ 'Amount must be in valid format and not more than 2 decimal places.' | translate }}
          </div>
        }
        <!-- FRC-858: block over-entry inline, before confirm/submit. -->
        @if (form.controls.amount.dirty && form.controls.amount.hasError('max')) {
          <div class="text-danger tw-mb-2 tw-text-xs tw-font-semibold">
            {{
              'mysec.amountExceedsWithdrawable'
                | translate: { amount: (withdrawableBalance | numberSuffix: { numberFormat: '1.2-2' }) }
            }}
          </div>
        }
        <!-- FRC-858: Withdrawable line (no icon). -->
        <div class="d-flex">
          <div class="small-text available-balance">
            {{ 'mysec.withdrawable' | translate }}
            <b class="text-black">{{
              withdrawableBalance | numberSuffix: { numberFormat: '1.2-2' }
            }}</b>
          </div>
        </div>
        <!-- FRC-858: Minimum line.
             State B (nothing withdrawable): replaced by the below-minimum notice + icon.
             State A (typed amount < RM1): the line turns red (no icon), reverts when valid. -->
        @if (isBelowMinimum) {
          <div class="d-flex tw-items-center tw-gap-1 text-danger">
            <svg
              aria-hidden="true"
              focusable="false"
              class="tw-flex-none"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.3"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 3 2.5 20h19L12 3Z" />
              <path d="M12 10v4M12 17.5v.01" />
            </svg>
            <div class="small-text text-danger">
              {{
                'mysec.withdrawableBelowMinimumTitle'
                  | translate: { min: (MinimumWithdrawAmount | numberSuffix: { numberFormat: '1.2-2' }) }
              }}
            </div>
          </div>
        } @else {
          <div class="d-flex">
            <div
              class="small-text"
              [ngClass]="isAmountBelowMinimum ? 'text-danger' : 'available-balance'"
            >
              {{ 'mysec.minimumWithdraw' | translate }}
              <b [ngClass]="isAmountBelowMinimum ? 'text-danger' : 'text-black'">{{
                MinimumWithdrawAmount | numberSuffix: { numberFormat: '1.2-2' }
              }}</b>
            </div>
          </div>
        }

        <!-- FRC-858: explain the gap in-place (no navigation, no breakdown-card duplication). -->
        @if (pendingAmount > 0) {
          <div class="tw-mt-3 tw-flex tw-items-start tw-gap-2 tw-rounded-lg tw-bg-[#FDF5E3] tw-p-3">
            <svg
              aria-hidden="true"
              focusable="false"
              class="tw-flex-none tw-text-[#B0740A]"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
              style="margin-top: 1px"
            >
              <circle cx="12" cy="12" r="9" />
              <path d="M12 11v5M12 7.5v.01" />
            </svg>
            <div class="tw-text-xs">
              <b>{{ pendingAmount | numberSuffix: { numberFormat: '1.2-2' } }}</b>
              {{ 'mysec.onHoldNotWithdrawable' | translate }}
            </div>
          </div>
        }

      </div>
    </div>
    <div class="row pb-4">
      <div class="col-12">
        <div class="tw-flex tw-justify-between">
          <div class="input-label font-size-smaller">{{ 'mysec.withdrawTo' | translate }}</div>
          <a
            target="_blank"
            routerLink="/profile/settings/payment-methods"
            class="font-size-smaller tw-cursor-pointer tw-text-link tw-underline hover:tw-no-underline"
            (click)="close()"
          >
            {{ 'mysec.switchAccount' | translate }}
          </a>
        </div>
        @if (!isLoading) {
          <div class="row bank-panel">
            <div class="col-7">
              <div class="font-size-larger font-weight-extrabold text-black">
                {{ paymentMethod?.bankName }}
              </div>
              <div class="bank-text font-size-smaller">{{ paymentMethod?.accountNumber }}</div>
            </div>
            <div class="col-5 text-right">
              <div class="bank-text small-text">
                <i>{{ 'settings.accountHolder' | translate }}</i>
              </div>
              <div class="font-size-smaller text-black">{{ paymentMethod?.accountHolder }}</div>
            </div>
          </div>
        }
        @if (isLoading) {
          <agmo-loading></agmo-loading>
        }
      </div>
    </div>
    <div class="tw-text-sm">
      {{ 'mysec.withdrawalDisclaimer' | translate }}
      <div>
        <a
          href="https://support.pitchin.my/hc/en-us/articles/13440132780573-How-long-will-it-take-for-my-MYR-top-up-or-withdrawal-to-be-processed"
          target="_blank"
          class="tw-mt-4"
        >
          {{ 'common.learnMore' | translate }}
        </a>
      </div>
    </div>
    <div class="row justify-content-center pb-3 tw-mt-8">
      <div class="col-md-10">
        <!-- FRC-858: also gate on the payment method — withdrawWallet() writes the amount
             onto it, so submitting before it resolves (or after the lookup failed) would
             throw and leave the block-UI overlay stuck. -->
        <button
          type="submit"
          class="btn btn-primary w-100"
          [disabled]="form.invalid || isBelowMinimum || isLoading || !paymentMethod"
        >
          {{ 'mysec.Withdraw' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
